import http from "infra/http";
import { useMutation } from "react-query";
import URL from "core/resources/urls";

export interface useTriggerJobResponse {
  processados: number[];
  naoEncontrados: number[];
  naoProcessados: number[];
}

export interface useTriggerJobProps {
  recurringJobGroupId: string;
}

export default function useTriggerJob() {
  return useMutation({
    mutationKey: [URL.RECURRING_JOB_GROUP.RUN_JOBS("recurringJobGroupId")],
    mutationFn: async ({ recurringJobGroupId }: useTriggerJobProps) => {
      const response = await http.post<useTriggerJobResponse, any>(
        `${URL.RECURRING_JOB_GROUP.RUN_JOBS(recurringJobGroupId)}`,
      );

      return response.data;
    },
  });
}
